import { UseCasePage } from "../components/UseCasePage";
import { customerSuccessRenewalCallCopy } from "../lib/translations/pages/use-case-customer-success-renewal-call";

export function CustomerSuccessRenewalCall() {
  return (
    <UseCasePage
      content={customerSuccessRenewalCallCopy}
      path="/use-cases/customer-success-renewal-call"
    />
  );
}
